"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-one/sections/faqSection.tsx */

import { SmartImage } from "@/Components";
import { SmartLink } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type FaqSectionAccordionsItem = {
    key: Key | null | undefined;
    /** Detected variants: "accordion-collapse collapse show" | "accordion-collapse collapse" */
    className: string;
    /** Detected variants: "Yes, simply visit our website and log in or create an account. Search for a doctor based on specialization, location, or availability & confirm your booking." | "Yes, you can usually request a specific doctor when booking your appointment, though availability may vary based on their schedule." | "If you need to cancel or reschedule your appointment, contact the doctor as soon as possible to inform them and to reschedule for another available time slot." | "If you know you will be late, it's courteous to call the doctor's office and inform them. Depending on their policy and schedule, they may be able to accommodate you or reschedule your appointment." | "Yes, in many cases, you can book appointments for family members or dependents. However, you may need to provide their personal information and consent to do so." */
    p0Text: ReactNode;
    /** Detected variants: "collapseOne" | "collapseTwo" | "collapseThree" | "collapseFour" | "collapseFive" */
    id: string;
    /** Detected variants: "headingOne" | "headingTwo" | "headingThree" | "headingFour" | "headingFive" */
    h30Id: string;
    /** Detected variants: "How do I book an appointment with a doctor?" | "Can I request a specific doctor when booking my appointment?" | "What should I do if I need to cancel or reschedule my appointment?" | "What if I'm running late for my appointment?" | "Can I book appointments for family members or dependents?" */
    link0Text: ReactNode;
    /** Detected variants: "collapseOne" | "collapseTwo" | "collapseThree" | "collapseFour" | "collapseFive" */
    ariaControls: string;
    /** Detected variants: "true" | "false" */
    ariaExpanded: boolean;
    /** Detected variants: "accordion-button" | "accordion-button collapsed" */
    link0ClassName: string;
    /** Detected variants: "#collapseOne" | "#collapseTwo" | "#collapseThree" | "#collapseFour" | "#collapseFive" */
    dataBsTarget: string;
    /** Detected variants: "accordion-item" */
    divClassName?: string;
    /** Detected variants: "#faq-details-one" */
    dataBsParent?: string;
    /** Detected variants: "accordion-body" */
    div0ClassName?: string;
    /** Detected variants: "accordion-content" */
    div0ClassName2?: string;
    /** Detected variants: "accordion-header" */
    h30ClassName?: string;
    /** Detected variants: "collapse" */
    dataBsToggle?: string;
    /** Detected variants: "#" */
    href?: string;
};
export type HomeOneFaqSectionGeneratedProps = {
    divH30H3Props?: Partial<ComponentProps<"h3">> | ((item: FaqSectionAccordionsItem) => Partial<ComponentProps<"h3">>);
    divH30Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: FaqSectionAccordionsItem) => Partial<ComponentProps<typeof SmartLink>>);
    /** Default: "1s" */
    sectionDiv0Div0DivDataWowDuration?: string;
    /** Default: "FAQ'S" */
    sectionDiv0Div0Div0DivText?: ReactNode;
    /** Default: "Your Questions are" */
    sectionDiv0Div0H20H2Text?: ReactNode;
    sectionDiv0Div0H20H2Visible?: boolean;
    sectionDiv0Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    /** Default: "Answered" */
    sectionDiv0Div0H20Span0SpanText?: ReactNode;
    sectionDiv0Div1ClassName?: string;
    /** Default: "1s" */
    sectionDiv0Div1Div0Div0DivDataWowDuration?: string;
    /** Default: "faq-details-one" */
    sectionDiv0Div1Div0Div0Div0DivId?: string;
    /** Default: "element" */
    sectionImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/faq-bg.png" */
    sectionImageWithBasePath0ImageSrc?: string;
    sectionImageWithBasePath0ImageVisible?: boolean;
    sectionImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "element" */
    sectionImageWithBasePath1ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/faq-bg-one.png" */
    sectionImageWithBasePath1ImageSrc?: string;
    sectionImageWithBasePath1ImageVisible?: boolean;
    sectionImageWithBasePath1ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionImageWithBasePath1ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    faqSectionAccordions: FaqSectionAccordionsItem[];
    faqSectionAccordionsItemWrapper?: (item: FaqSectionAccordionsItem, content: ReactNode) => ReactNode;
    faqSectionAccordionsRenderer?: (defaultNode: ReactNode) => ReactNode;
    faqSectionAccordionsLinkVisible?: boolean;
    faqSectionAccordionsLinkRenderer?: (item: FaqSectionAccordionsItem, defaultNode: ReactNode) => ReactNode;
    faqSectionAccordionsH3Visible?: boolean;
    faqSectionAccordionsH3Renderer?: (item: FaqSectionAccordionsItem, defaultNode: ReactNode) => ReactNode;
    faqSectionAccordionsLinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: FaqSectionAccordionsItem) => Partial<ComponentProps<typeof SmartLink>>);
    faqSectionAccordionsH3Props?: Partial<ComponentProps<"h3">> | ((item: FaqSectionAccordionsItem) => Partial<ComponentProps<"h3">>);
};

const HomeOneFaqSectionGenerated: FC<HomeOneFaqSectionGeneratedProps> = ({
    sectionDiv0Div0Div0DivText = "FAQ'S",
    sectionDiv0Div0DivDataWowDuration = "1s",
    sectionDiv0Div0H20H2Text = "Your Questions are",
    sectionDiv0Div0H20H2Visible,
    sectionDiv0Div0H20H2Renderer,
    sectionDiv0Div0H20H2Props,
    sectionDiv0Div0H20Span0SpanText = "Answered",
    sectionDiv0Div1Div0Div0Div0DivId = "faq-details-one",
    sectionDiv0Div1Div0Div0DivDataWowDuration = "1s",
    sectionImageWithBasePath0ImageAlt = "element",
    sectionImageWithBasePath0ImageSrc = "/Templates/Doccure/img/bg/faq-bg.png",
    sectionImageWithBasePath0ImageVisible,
    sectionImageWithBasePath0ImageRenderer,
    sectionImageWithBasePath0ImageProps,
    sectionImageWithBasePath1ImageAlt = "element",
    sectionImageWithBasePath1ImageSrc = "/Templates/Doccure/img/bg/faq-bg-one.png",
    sectionImageWithBasePath1ImageVisible,
    sectionImageWithBasePath1ImageRenderer,
    sectionImageWithBasePath1ImageProps,
    divH30H3Props,
    divH30Link0LinkProps,
    sectionDiv0Div1ClassName,
    faqSectionAccordions,
    faqSectionAccordionsItemWrapper,
    faqSectionAccordionsRenderer,
    faqSectionAccordionsLinkVisible,
    faqSectionAccordionsLinkRenderer,
    faqSectionAccordionsH3Visible,
    faqSectionAccordionsH3Renderer,
    faqSectionAccordionsLinkProps,
    faqSectionAccordionsH3Props,
}) => {
    return (
        <section className="faq-section-one section">
            <div className="container">
                <div className="section-header section-header-one text-center wow slideInLeft" data-wow-duration={sectionDiv0Div0DivDataWowDuration}>
                    <div className="title">{sectionDiv0Div0Div0DivText}</div>
                    {renderNode(sectionDiv0Div0H20H2Visible, sectionDiv0Div0H20H2Renderer, (
                        <h2 className="section-title" {...(sectionDiv0Div0H20H2Props ?? {})}>
                            {" "}
                            {sectionDiv0Div0H20H2Text}
                            <span className="text-primary">
                                {sectionDiv0Div0H20Span0SpanText}
                                {" "}
                            </span>
                            {" "}
                        </h2>
                    ))}
                </div>
                <div className={sectionDiv0Div1ClassName ?? "row"}>
                    <div className="col-md-10 mx-auto">
                        <div className="faq-info wow zoomIn" data-wow-duration={sectionDiv0Div1Div0Div0DivDataWowDuration}>
                            <div className="accordion" id={sectionDiv0Div1Div0Div0Div0DivId}>
                                {renderCollectionNode(
                                    faqSectionAccordions,
                                    (item: FaqSectionAccordionsItem) => (
                                        <div className={item.divClassName ?? "accordion-item"} key={item.key}>
                                            {renderItemNode(faqSectionAccordionsH3Visible, faqSectionAccordionsH3Renderer, item, (
                                                <h3 className={item.h30ClassName ?? "accordion-header"} id={item.h30Id} {...(typeof faqSectionAccordionsH3Props === "function" ? faqSectionAccordionsH3Props(item) : (faqSectionAccordionsH3Props ?? {}))} {...(typeof divH30H3Props === "function" ? divH30H3Props(item) : (divH30H3Props ?? {}))}>
                                                    {renderItemNode(faqSectionAccordionsLinkVisible, faqSectionAccordionsLinkRenderer, item, (
                                                        <SmartLink href={item.href ?? "#"} className={item.link0ClassName} data-bs-toggle={item.dataBsToggle ?? "collapse"} data-bs-target={item.dataBsTarget} aria-expanded={item.ariaExpanded} aria-controls={item.ariaControls} {...(typeof faqSectionAccordionsLinkProps === "function" ? faqSectionAccordionsLinkProps(item) : (faqSectionAccordionsLinkProps ?? {}))} {...(typeof divH30Link0LinkProps === "function" ? divH30Link0LinkProps(item) : (divH30Link0LinkProps ?? {}))}>{item.link0Text}</SmartLink>
                                                    ))}
                                                </h3>
                                            ))}
                                            <div id={item.id} className={item.className} data-bs-parent={item.dataBsParent ?? "#faq-details-one"}>
                                                <div className={item.div0ClassName ?? "accordion-body"}>
                                                    <div className={item.div0ClassName2 ?? "accordion-content"}>
                                                        <p>{item.p0Text}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ),
                                    faqSectionAccordionsItemWrapper,
                                    faqSectionAccordionsRenderer
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {renderNode(sectionImageWithBasePath0ImageVisible, sectionImageWithBasePath0ImageRenderer, (
                <SmartImage src={sectionImageWithBasePath0ImageSrc} alt={sectionImageWithBasePath0ImageAlt} className="img-fluid element-01" {...(sectionImageWithBasePath0ImageProps ?? {})} />
            ))}
            {renderNode(sectionImageWithBasePath1ImageVisible, sectionImageWithBasePath1ImageRenderer, (
                <SmartImage src={sectionImageWithBasePath1ImageSrc} alt={sectionImageWithBasePath1ImageAlt} className="img-fluid element-02" {...(sectionImageWithBasePath1ImageProps ?? {})} />
            ))}
        </section>
    );
};

export default HomeOneFaqSectionGenerated;
